<template>
  <el-row>
    <el-col :span="12" :offset="6">
      <el-divider>Password</el-divider>
      <div>
        <el-form ref="form" :model="edit" label-width="160px">
          <el-form-item label="Old Password" prop="password_old">
            <el-input type="password" v-model="edit.password_old"></el-input>
          </el-form-item>
          <el-form-item
            label="New Password"
            prop="password_new"
            :rules="[{ validator: validatePass, required: true }]"
          >
            <el-input type="password" v-model="edit.password_new"></el-input>
          </el-form-item>
          <el-form-item
            label="Repeat Password"
            prop="password_new2"
            :rules="[{ validator: validatePass, required: true }]"
          >
            <el-input type="password" v-model="edit.password_new2"></el-input>
          </el-form-item>
          <el-button type="primary" @click="savePassword()">Save Password</el-button>
        </el-form>
        <el-divider>Two-Factor-Authentication</el-divider>
        <div>
          <el-switch
            active-text="Enable 2-Factor-Authentication"
            @change="handle2FA"
            v-model="fa_active"
          ></el-switch>
          <div v-if="fa_active && url" style="padding: 15px;">
            <span>Please scan the code with Google Authenticator App and insert token below</span>
            <br />
            <img style="width: 200px; height: 200px" :src="url" />
            <br />
            <div>
              <el-input v-model="token" maxlength="6" style="width: 200px"></el-input>
              <el-button @click="sendEnableToken" style="display: inline-block;">Submit</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { validatePass } from "../lib/password-validation";
import { LoadQR, LoadAccount, EnableOtp, DisableOtp, ChangePassword } from "../api.js";

export default {
  name: "Account",
  props: {},
  components: {},
  data: function() {
    return {
      edit: {
        password_old: "",
        password_new: "",
        password_new2: ""
      },
      url: "",
      fa_active: false,
      token: ""
    };
  },
  methods: {
    validatePass,
    async loadData() {
      const accountData = await LoadAccount();
      this.fa_active = accountData.otp_enabled;
    },
    async savePassword() {
      if (this.edit.password_new === this.edit.password_new2) {
        const result = await ChangePassword(this.edit);
        if (result === "OK") {
          alert("Password changed successfully");
          this.edit = {};
        }
      } else {
        alert("Passwords has to be the same!");
      }
    },
    async handle2FA(active) {
      if (active === true) {
        this.url = await LoadQR();
      } else {
        await DisableOtp();
      }
    },
    async sendEnableToken() {
      const response = await EnableOtp(this.token);
      if (response === "OK") {
        this.url = "";
        alert("2FA Successfully enabled.");
      } else {
        alert("Wrong Token, please try again");
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

